export const baseUrl = "/";
export const baseUrlNoEndSlash = "";

// export const baseUrl = "http://localhost:8000/";
// export const baseUrlNoEndSlash = "http://localhost:8000";